<script>
/**
 * Fix of element Select using remote (autocomplete).
 * for all other use of select, use original component
*/
import { Select } from 'element-ui';

export default {
  name: 'RemoteSelect',
  extends: Object.assign({}, Select, {
    computed: Object.assign({}, Select.computed, {
      readonly() {
        /**
         *trade-off for mobile/IE input readonly problem
         * https://github.com/ElemeFE/element/issues/10403
        */
        const isIE = !this.$isServer && !Number.isNaN(Number(document.documentMode));

        return !(this.filterable || this.multiple || !isIE) && !this.visible;
      }
    })
  })
};
</script>
